// import { useState, useEffect, useCallback } from "react";
// import Footer from "../standartComponent/footer/footer";
// import Header from "../standartComponent/header/header";
// import css from "./order.module.css";
// import { v4 as uuidv4 } from "uuid";
// import Swal from "sweetalert2";
// import withUserData from "../HOK/withUserData";
// import logoForSlidef from "../../svg/logoForSlidef.svg";
// import { getDocs, getDoc } from "firebase/firestore";
// import arrowImp from "../../img/arrowDownPick.png";
// // import fetchDepartments from "../../function/fetchDepartments";
// import { auth, db } from "../../firebase";

// import { doc, setDoc, collection, serverTimestamp } from "firebase/firestore";
// import ProductInOrder from "./productInOrder";
// import axios from "axios";
// import { Circles } from "react-loader-spinner";
// import { useCartCalculations } from "./useCartCalculations";

// const Order = ({ setLogin, user, discountInHok, dataFromBase }) => {
//   const NP_API_URL = "https://api.novaposhta.ua/v2.0/json/";
//   const [novaPoshtaKey, setNovaPoshtaKey] = useState("");
//   const [name, setName] = useState("");
//   const uid = uuidv4();
//   const [loading, setLoading] = useState(false);
//   const [fatherName, setFatherName] = useState("");
//   const [surName, setSurName] = useState("");
//   const [phone, setPhone] = useState("");
//   const [nameOtr, setNameOtr] = useState("");
//   const [fatherNameOtr, setFatherNameOtr] = useState("");
//   const [surNameOtr, setSurNameOtr] = useState("");
//   const [phoneOtr, setPhoneOtr] = useState("");
//   const [selectedCity, setSelectedCity] = useState();
//   const [isNewBuyer, setIsNewBuyer] = useState(true);
//   const [ulVisible, setUlVisible] = useState(false);
//   const [ulVisibleVid, setUlVisibleVid] = useState(false);
//   const [departments, setDepartments] = useState([]);
//   const [visibleForm, setVisibleForm] = useState(false);
//   const [whatSelect, setWhatSelect] = useState(0);
//   const [discount, setDiscount] = useState(null);
//   const [promo, setPromo] = useState("");
//   const [fullPrice, setFullPrice] = useState();
//   const [products, setProducts] = useState([]);
//   const [haveProduct, setHaveProduct] = useState(false);
//   const [cartProducts, setCartProducts] = useState();
//   const [promoApplied, setPromoApplied] = useState(false);
//   const [currentUs, setCurrentUs] = useState(null);

//   const [depo, setDepo] = useState("");
//   const [selectedDepartment, setSelectedDepartment] = useState("");
//   const [countProductForCart, setCountProductForCart] = useState([]);
//   const [whoCust, setWhoCust] = useState(true);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filteredDepartments, setFilteredDepartments] = useState([]);
//   const [selectedCountry, setSelectedCountry] = useState("0");
//   const [selectedDeliveryMethod, setSelectedDeliveryMethod] = useState("0");
//   const {
//     totalPrice,
//     newFinValue,
//     visibleDiscount,
//     promoCode,
//     setPromoCode,
//     applyPromoCode,
//     applyElefant,
//   } = useCartCalculations({
//     cartProducts,
//     discountInHok,
//     currentUser: currentUs,
//   });
//   const loadDepartmentsForCity = useCallback(
//     async (cityRef, cityNameForFallback = "") => {
//       if (!novaPoshtaKey || !cityRef) {
//         setDepartments([]);
//         setFilteredDepartments([]);
//         return;
//       }

//       const fetchWarehouses = async (props) => {
//         const body = {
//           apiKey: novaPoshtaKey,
//           modelName: "AddressGeneral",
//           calledMethod: "getWarehouses",
//           methodProperties: {
//             Page: "1",
//             Limit: "500",
//             Language: "UA",
//             ...props, // CityRef або SettlementRef
//           },
//         };
//         const res = await fetch(NP_API_URL, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(body),
//         });
//         const data = await res.json();
//         return Array.isArray(data?.data) ? data.data : [];
//       };

//       try {
//         // 1) Спершу пробуємо за CityRef
//         let list = await fetchWarehouses({ CityRef: cityRef });

//         // 2) Якщо пусто — шукаємо Settlement і пробуємо з SettlementRef
//         if ((!list || list.length === 0) && cityNameForFallback) {
//           const searchRes = await fetch(NP_API_URL, {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({
//               apiKey: novaPoshtaKey,
//               modelName: "Address",
//               calledMethod: "searchSettlements",
//               methodProperties: {
//                 CityName: cityNameForFallback,
//                 Limit: 10,
//                 Page: "1",
//                 Language: "UA",
//               },
//             }),
//           });
//           const searchJson = await searchRes.json();
//           // у відповіді зазвичай data[0].Addresses — масив населених пунктів
//           const addresses = Array.isArray(searchJson?.data?.[0]?.Addresses)
//             ? searchJson.data[0].Addresses
//             : [];
//           const settlementRef =
//             addresses[0]?.Ref || addresses[0]?.SettlementRef || null;

//           if (settlementRef) {
//             list = await fetchWarehouses({ SettlementRef: settlementRef });
//           }
//         }

//         setDepartments(list);
//         setFilteredDepartments(list);
//       } catch (e) {
//         console.error("Error fetching NP departments:", e);
//         setDepartments([]);
//         setFilteredDepartments([]);
//       }
//     },
//     [novaPoshtaKey]
//   );

//   useEffect(() => {
//     const fetchCurrentUser = async () => {
//       if (user && user.uid) {
//         const userDocRef = doc(db, "users", user.uid);
//         const userDoc = await getDoc(userDocRef);
//         if (userDoc.exists()) {
//           setCurrentUs(userDoc.data());
//         }
//       }
//     };
//     if (user) {
//       fetchCurrentUser();
//     }
//   }, [user]);
//   useEffect(() => {
//     const usedPromo = localStorage.getItem("usedPromoCode");
//     if (usedPromo) {
//       setPromoApplied(true);
//     }
//   }, []);

//   const handleApplyPromoCode = useCallback(async () => {
//     if (!cartProducts || cartProducts.length === 0) {
//       Swal.fire({
//         icon: "info",
//         title: "Зачекайте",
//         text: "Товари ще не завантажені. Спробуйте за кілька секунд.",
//       });
//       return; // ❗️ Зупиняє виконання!
//     }

//     const promoCollectionRef = collection(db, "promo");
//     const snapshot = await getDocs(promoCollectionRef);

//     let found = false;

//     for (const docSnap of snapshot.docs) {
//       const promoData = {
//         ...docSnap.data(),
//         id: docSnap.id,
//       };

//       if (
//         promoData.code.trim().toLowerCase() === promoCode.trim().toLowerCase()
//       ) {
//         found = true;

//         // 🔑 Передаємо саме актуальний cartProducts!

//         const success = await applyPromoCode(promoData, cartProducts);

//         if (success) {
//           Swal.fire({
//             icon: "success",
//             title: "Промокод застосовано",
//             text: `Знижка ${promoData.discount}% активована!`,
//           });
//           localStorage.setItem("usedPromoCode", promoCode);
//           setPromoApplied(true);
//           setPromoCode("");
//         } else {
//           Swal.fire({
//             icon: "info",
//             title: "Не застосовано",
//             text: "Цей промокод не підходить до вибраних товарів.",
//           });
//         }
//         break;
//       }
//     }

//     if (!found) {
//       Swal.fire({
//         icon: "error",
//         title: "Помилка",
//         text: "Такого промокоду не існує.",
//       });
//     }
//   }, [applyPromoCode, promoCode, cartProducts]);

//   const handleApplyelefant = async () => {
//     if (!currentUs || !currentUs.elefant || parseInt(currentUs.elefant) === 0) {
//       Swal.fire({
//         icon: "info",
//         title: "Увага",
//         text: "У вас немає доступних слонів для списання.",
//       });
//       return;
//     }

//     const elephantsUsed = await applyElefant(async (uid) => {
//       const userDocRef = doc(db, "users", uid);
//       await setDoc(userDocRef, { elefant: "0" }, { merge: true });
//       setCurrentUs((prev) => ({ ...prev, elefant: "0" }));
//     });

//     if (elephantsUsed === false) {
//       Swal.fire({
//         icon: "info",
//         title: "Увага",
//         text: "У вас немає доступних слонів для списання.",
//       });
//     } else {
//       Swal.fire({
//         icon: "success",
//         title: "Слони застосовані!",
//         text: `Сума замовлення зменшена на ${elephantsUsed} грн.`,
//       });
//     }
//   };

//   const handleNewBuyerClick = () => {
//     setIsNewBuyer(true);
//   };

//   const handleAlwaysBuyerClick = () => {
//     setIsNewBuyer(false);
//   };

//   const handleDepartmentClick = (department) => {
//     setSelectedDepartment(department.Description);
//     setSearchTerm(department.Description);
//     setUlVisibleVid(false); // Hide dropdown after selection
//   };
//   const handleSelectChange = (event) => {
//     const selectedIndex = event.target.value;
//     const selectedDepartmentName =
//       departments[selectedIndex]?.Description || "";
//     setSelectedDepartment(selectedDepartmentName);
//   };

//   const [choisDostavka, setChoisDostavka] = useState(true);

//   const nameChangeOtr = (e) => {
//     const na = e.target.value;
//     setNameOtr(na);
//   };
//   const fatherNameChangeOtr = (e) => {
//     const fa = e.target.value;
//     setFatherNameOtr(fa);
//   };
//   const surNameChangeOtr = (e) => {
//     const sa = e.target.value;
//     setSurNameOtr(sa);
//   };
//   const handlePhoneChangeOtr = (event) => {
//     const newPhone = event.target.value;

//     if (newPhone.startsWith("") && newPhone.length <= 13) {
//       setPhoneOtr(newPhone);
//     }
//   };

//   const nameChange = (e) => {
//     const na = e.target.value;
//     setName(na);
//   };
//   const fatherNameChange = (e) => {
//     const fa = e.target.value;
//     setFatherName(fa);
//   };
//   const surNameChange = (e) => {
//     const sa = e.target.value;
//     setSurName(sa);
//   };
//   const handlePhoneChange = (event) => {
//     const newPhone = event.target.value;

//     if (newPhone.startsWith("") && newPhone.length <= 13) {
//       setPhone(newPhone);
//     }
//   };

//   const [selectedOption, setSelectedOption] = useState(null);

//   const handleOptionClick = (option) => {
//     if (selectedOption === option) {
//       setSelectedOption("");
//     } else {
//       setSelectedOption(option);
//     }
//     setWhoCust(!whoCust);
//   };

//   const [cityName, setCityName] = useState("");
//   const [cities, setCities] = useState([]);

//   useEffect(() => {
//     const fetchNovaPoshtaKey = async () => {
//       try {
//         // Припустимо, що ключ зберігається в колекції "novapost" в документі "novaPoshtaData" у полі "key"
//         const keyDocRef = doc(db, "novapost", "novaPoshtaData");
//         const keyDocSnap = await getDoc(keyDocRef);
//         if (keyDocSnap.exists()) {
//           setNovaPoshtaKey(keyDocSnap.data().key || "");
//         } else {
//         }
//       } catch (error) {
//         console.error("Помилка завантаження ключа Нової Пошти:", error);
//       }
//     };
//     fetchNovaPoshtaKey();
//   }, []);
//   const handleInputChange = async (event) => {
//     const inputCityName = event.target.value;

//     if (!novaPoshtaKey) {
//       console.error("Ключ Нової Пошти не завантажено");
//       return;
//     }
//     setCityName(inputCityName);
//     setUlVisible(true);
//     try {
//       const apiUrl = "https://api.novaposhta.ua/v2.0/json/";
//       const requestData = {
//         apiKey: novaPoshtaKey,
//         modelName: "Address",
//         calledMethod: "getCities",
//         methodProperties: {
//           FindByString: inputCityName,
//         },
//       };

//       const response = await fetch(apiUrl, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(requestData),
//       });

//       const data = await response.json();

//       const citiesList = data.data || [];

//       setCities(citiesList);
//     } catch (error) {
//       console.error("Error searching cities:", error);
//     }
//   };

//   // const handleCityClick = async (city) => {
//   //   setSelectedCity(city);
//   //   setCityName(city.Description);
//   //   setCities([]);
//   //   setUlVisible(false);

//   //   setDepartments(await fetchDepartments(city.Ref));
//   // };
//   const handleCityClick = async (city) => {
//     setSelectedCity(city);
//     setCityName(city.Description);
//     setCities([]);
//     setUlVisible(false);
//     setSelectedDeliveryMethod("1"); // одразу фіксуємо "Нова пошта"
//     setSelectedDepartment("");
//     setSearchTerm("");
//     await loadDepartmentsForCity(city.Ref, city.Description);
//   };
//   // useEffect(() => {
//   //   const fetchData = async () => {
//   //     try {
//   //       const departmentsData = await fetchDepartments(selectedCity?.Ref || "");

//   //       setDepartments(departmentsData);
//   //       setFilteredDepartments(departmentsData);
//   //     } catch (error) {
//   //       console.error("Error fetching departments", error);
//   //     }
//   //   };

//   //   fetchData();
//   // }, [selectedCity]);
//   useEffect(() => {
//     if (selectedCity?.Ref) {
//       loadDepartmentsForCity(selectedCity.Ref);
//     } else {
//       setDepartments([]);
//       setFilteredDepartments([]);
//     }
//   }, [selectedCity, loadDepartmentsForCity]);
//   useEffect(() => {
//     const fetchProducts = async () => {
//       const productsRef = collection(db, "product");
//       const productsSnapshot = await getDocs(productsRef);
//       const productsList = productsSnapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));

//       const bundlesSnapshot = await getDocs(collection(db, "bundles"));
//       const bundles = bundlesSnapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));

//       const actionsSnapshot = await getDocs(collection(db, "actions"));
//       const actions = actionsSnapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));

//       // ⬇️ нове: розпродажі
//       const salesSnapshot = await getDocs(collection(db, "sales"));
//       const sales = salesSnapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));

//       const now = new Date();
//       const cartLocal = JSON.parse(localStorage.getItem("cart")) || [];

//       const withFlags = cartLocal.map((cartItem) => {
//         const product = productsList.find((p) => p.id === cartItem.uid);

//         // --- знайти акцію
//         let actionDiscount = null;
//         const matchedAction = actions.find((action) => {
//           const start = action.startDate ? new Date(action.startDate) : null;
//           const end = action.endDate ? new Date(action.endDate) : null;

//           if (end && now > end) return false;
//           if (start && now < start) return false;

//           const matchProduct = action.appliesTo?.products?.includes(product.id);

//           const productSeries = Array.isArray(product.seria)
//             ? product.seria
//             : typeof product.seria === "string" && product.seria !== ""
//             ? [product.seria]
//             : [];

//           const matchSeries = productSeries.some((ser) =>
//             action.appliesTo?.series?.includes(ser)
//           );

//           const productAuthors = Array.isArray(product.textAutor)
//             ? product.textAutor.map((a) => a.split(" ")[0].trim())
//             : typeof product.textAutor === "string" && product.textAutor !== ""
//             ? [product.textAutor.split(" ")[0].trim()]
//             : [];

//           const actionAuthors = Array.isArray(action.appliesTo?.authors)
//             ? action.appliesTo.authors.map((a) => a.split(" ")[0].trim())
//             : [];

//           const matchAuthor = productAuthors.some((a) =>
//             actionAuthors.includes(a)
//           );

//           return matchProduct || matchSeries || matchAuthor;
//         });
//         if (matchedAction) actionDiscount = matchedAction.discountPercent;

//         // --- знайти розпродаж
//         let saleDiscount = null;
//         const matchedSale = sales.find((sale) => {
//           const start = sale.startDate ? new Date(sale.startDate) : null;
//           const end = sale.endDate ? new Date(sale.endDate) : null;

//           if (end && now > end) return false;
//           if (start && now < start) return false;

//           const applies = sale.appliesTo || {};
//           const matchProduct =
//             Array.isArray(applies.products) &&
//             applies.products.includes(product.id);

//           // series інколи seria
//           const productSeries = Array.isArray(product.seria)
//             ? product.seria
//             : typeof product.seria === "string" && product.seria !== ""
//             ? [product.seria]
//             : Array.isArray(product.series)
//             ? product.series
//             : typeof product.series === "string" && product.series !== ""
//             ? [product.series]
//             : [];

//           const matchSeries =
//             Array.isArray(applies.series) &&
//             productSeries.some((ser) => applies.series.includes(ser));

//           const productAuthors = Array.isArray(product.textAutor)
//             ? product.textAutor.map((a) => a.split(" ")[0].trim())
//             : typeof product.textAutor === "string" && product.textAutor !== ""
//             ? [product.textAutor.split(" ")[0].trim()]
//             : [];

//           const saleAuthors = Array.isArray(applies.authors)
//             ? applies.authors.map((a) => a.split(" ")[0].trim())
//             : [];

//           const matchAuthor = productAuthors.some((a) =>
//             saleAuthors.includes(a)
//           );

//           return matchProduct || matchSeries || matchAuthor;
//         });
//         if (matchedSale)
//           saleDiscount = Number(matchedSale.discountPercent) || 0;

//         return {
//           ...product,
//           quantity: cartItem.quantity,
//           actionDiscountPercent: actionDiscount,
//           saleDiscountPercent: saleDiscount, // ⬅️ підкладено
//         };
//       });

//       // --- бандли (залишаю ваш підхід)
//       bundles.forEach((bundle) => {
//         const bundleProductIds = bundle.products.map((p) =>
//           p.productId?.trim()
//         );
//         let inCart = withFlags.filter((p) =>
//           bundleProductIds.includes(p.id?.trim())
//         );

//         if (inCart.length >= bundle.products.length) {
//           inCart.forEach((item) => {
//             const matchBundleItem = bundle.products.find(
//               (p) => p.productId?.trim() === item.id?.trim()
//             );
//             if (matchBundleItem?.discount) {
//               // у вас далі логіка спирається на actionDiscountPercent — не чіпаю
//               item.actionDiscountPercent = matchBundleItem.discount;
//             }
//           });
//         }
//       });

//       setCartProducts(withFlags);
//       setHaveProduct(true);
//     };

//     fetchProducts();
//   }, []);

//   const [totalQuantity, setTotalQuantity] = useState(0);
//   const handleQuantityChange = (uid, quantity) => {
//     const updatedCartProducts = cartProducts.map((product) => {
//       if (product.uid === uid) {
//         return {
//           ...product,
//           quantity,
//         };
//       } else {
//         return product;
//       }
//     });
//     const productToUpdate = updatedCartProducts.find(
//       (product) => product.uid === uid
//     );
//     const totalPrice = updatedCartProducts.reduce((acc, product) => {
//       return acc + product.price * product.quantity;
//     }, 0);

//     if (discountInHok > 0) {
//       const discValue = (totalPrice * discountInHok) / 100;
//       const resul = totalPrice - discValue;

//       setDiscount(discValue);
//     } else {
//       setCartProducts(updatedCartProducts);
//     }

//     setCartProducts(updatedCartProducts);

//     if (productToUpdate) {
//       const cart = JSON.parse(localStorage.getItem("cart"));
//       const updatedCart = cart.map((product) => {
//         if (product.uid === uid) {
//           return {
//             ...product,
//             quantity,
//           };
//         } else {
//           return product;
//         }
//       });
//       localStorage.setItem("cart", JSON.stringify(updatedCart));
//     }

//     const totalQuantity = updatedCartProducts.reduce((acc, product) => {
//       return acc + product.quantity;
//     }, 0);
//     setTotalQuantity(totalQuantity);
//   };

//   const removeProduct = (uid) => {
//     const updatedCart = cartProducts.filter((product) => product.uid !== uid);
//     localStorage.setItem("cart", JSON.stringify(updatedCart));
//     setCartProducts(updatedCart);

//     const totalQuantity = updatedCart.reduce((acc, product) => {
//       return acc + product.quantity;
//     }, 0);
//     setTotalQuantity(totalQuantity);

//     const totalPrice = updatedCart.reduce((acc, product) => {
//       return acc + product.price * product.quantity;
//     }, 0);

//     if (discountInHok > 0) {
//       const discValue = (totalPrice * discountInHok) / 100;
//       const resul = totalPrice - discValue;
//       setCartProducts(updatedCart);
//       setDiscount(discValue);
//     } else {
//       setCartProducts(updatedCart);
//     }
//   };
//   useEffect(() => {
//     if (cartProducts && cartProducts.length) {
//       const totalQuantity = cartProducts.reduce((acc, product) => {
//         return acc + product.quantity;
//       }, 0);
//       setCountProductForCart(totalQuantity);
//     }
//   }, [cartProducts]);

//   const validateForm = () => {
//     if (!name.trim() || !surName.trim() || !phone.trim()) {
//       Swal.fire({
//         icon: "error",
//         title: "Помилка",
//         text: "Будь ласка, заповніть усі обов'язкові поля: Ім'я, Прізвище, Телефон.",
//       });
//       return false;
//     }

//     if (
//       !selectedOption &&
//       (!nameOtr.trim() || !surNameOtr.trim() || !phoneOtr.trim())
//     ) {
//       Swal.fire({
//         icon: "error",
//         title: "Помилка",
//         text: "Будь ласка, заповніть дані отримувача: Ім'я, Прізвище, Телефон.",
//       });
//       return false;
//     }

//     if (!cityName.trim()) {
//       Swal.fire({
//         icon: "error",
//         title: "Помилка",
//         text: "Будь ласка, введіть місто для доставки.",
//       });
//       return false;
//     }

//     if (!(selectedDepartment || "").trim()) {
//       Swal.fire({
//         icon: "error",
//         title: "Помилка",
//         text: "Будь ласка, виберіть відділення Нової пошти.",
//       });
//       return false;
//     }

//     return true;
//   };
//   const payParam = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) {
//       return;
//     }
//     const json = JSON.stringify(cartProducts);

//     let us = "";

//     if (user) {
//       us = user.uid;
//     }
//     setLoading(true);
//     try {
//       const newProduct = {
//         uid: uid,
//         choice: json,
//         totalPrice: totalPrice,
//         finishPrice: newFinValue,
//         phone: phone,
//         name: name,
//         fatherName: fatherName,
//         surName: surName,
//         discount: discountInHok,
//         nameOtr,
//         fatherNameOtr,
//         surNameOtr,
//         phoneOtr,
//         isNewBuyer,
//         cityName,
//         selectedDepartment,
//         pay: "card",
//         paymentStatus: "false",
//         user: us,
//         status: "Очікує підтвердження",
//         createdAt: serverTimestamp(),
//       };

//       const frankDocRef = doc(db, "orders", uid);
//       await setDoc(frankDocRef, newProduct);

//       // const apiUrl = "http://localhost:4000/create-order";
//       // await axios.post(apiUrl, newProduct);

//       const payload = {
//         id: uid,
//         amount: totalPrice * 100,
//         ccy: 980,

//         merchantPaymInfo: {
//           reference: "84d0070ee4e44667b31371d8f8813947",
//           destination: "Оплата товарів час майстрів",
//           comment: "Оплата товарів час майстрів",
//           customerEmails: [],
//           basketOrder: [
//             ...cartProducts.map((product) => ({
//               name: product.bookName,
//               qty: product.quantity,
//               sum: product.price * 100,
//               icon: product.imageList[0],
//               unit: "шт.",
//               code: product.ISBN,
//             })),
//           ],
//         },
//         webHookUrl: "https://chas-maistriv.com.ua/api/webhook",
//         paymentType: "debit",
//         saveCardData: {
//           saveCard: true,
//           walletId: "69f780d841a0434aa535b08821f4822c",
//         },
//         redirectUrl: "https://chas-maistriv.com.ua/",
//         initiationKind: "merchant",
//         tds: true,
//         newProduct,
//       };
//       const response = await axios.post(
//         "https://chas-maistriv.com.ua/api/create-payment",
//         payload,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             // "X-Token": "mCJEvBVuVEnzrnbdGjjXXxg", // Додайте свій токен
//           },
//         }
//       );
//       if (response.data && response.statusText === "OK") {
//         // const revBal = response.data.amount + parseInt(currentUser.balance, 10);

//         // updateUserBalance(currentUser.uid, revBal);
//         // updateUserInvoiceInFirebase(response.data.invoiceId);
//         window.location.href = response.data.pageUrl;
//       }
//       // document.getElementById("liqpay-form").submit();
//     } catch (error) {
//       console.error("Помилка при додаванні документа:", error);
//     }

//     localStorage.removeItem("cart");
//   };

//   useEffect(() => {
//     if (currentUs && currentUs.displayName) {
//       const [first, last] = currentUs.displayName.split(" ");
//       setName(first);
//       setSurName(last);
//       setPhone(currentUs.phone);
//     }
//     if (
//       currentUs &&
//       typeof currentUs.deliveryCity === "object" &&
//       currentUs.deliveryCity !== null
//     ) {
//       setSelectedCity(currentUs.deliveryCity);
//       setCityName(currentUs.deliveryCity?.Description || "");
//       setSelectedDepartment(currentUs.deliveryDepartment);
//       setSearchTerm(currentUs.deliveryDepartment || "");
//       setSelectedCountry("1");
//       setSelectedDeliveryMethod("1");
//       if (currentUs.deliveryCity?.Ref) {
//         loadDepartmentsForCity(
//           currentUs.deliveryCity.Ref,
//           currentUs.deliveryCity?.Description || ""
//         );
//       }
//     } else {
//       setSelectedCity(null);
//       setSearchTerm("");
//     }

//     // setDeliveryDepartment(currentUs.deliveryDepartment || "");
//   }, [currentUs, loadDepartmentsForCity]);
//   const handleDepartmentSearch = (event) => {
//     const searchValue = event.target.value;
//     setSearchTerm(searchValue);

//     // Filter departments based on search value
//     // const filtered = departments.filter((department) =>
//     const filtered = (Array.isArray(departments) ? departments : []).filter(
//       (department) =>
//         department.Description.toLowerCase().includes(searchValue.toLowerCase())
//     );

//     setFilteredDepartments(filtered);
//     setUlVisibleVid(true); // Show dropdown when user starts typing
//   };
//   const handleInputClick = () => {
//     // setUlVisibleVid((prev) => !prev);
//     setFilteredDepartments(Array.isArray(departments) ? departments : []);
//     setUlVisibleVid(true);
//   };

//   return (
//     <>
//       <div className={css.blueHeaderOrder}>
//         <div className={css.blueHeaderOrderEnter}>
//           <h3 className={css.titleH3OrderEnter}>Оформлення замовлення</h3>
//         </div>
//       </div>
//       <div className={css.wrapCenterOrder}>
//         <div className={css.wrapCenterOrderSmall}>
//           <div className={css.firstBlockWrap}>
//             {!currentUs && (
//               <div className={css.newUserOrNoWrap}>
//                 <div
//                   className={`${css.newAlwaysBayer} ${
//                     isNewBuyer ? css.newBayer : ""
//                   }`}
//                   onClick={handleNewBuyerClick}
//                 >
//                   Я новий покупець
//                 </div>
//                 <div
//                   className={`${css.newAlwaysBayer} ${
//                     !isNewBuyer ? css.newBayer : ""
//                   }`}
//                   onClick={handleAlwaysBuyerClick}
//                 >
//                   Я постійний покупець
//                 </div>
//               </div>
//             )}
//             {!user && (
//               <p className={css.registerToOrder}>
//                 <span
//                   onClick={() => setLogin(true)}
//                   className={css.registerToOrderSpan}
//                 >
//                   ЗАРЕЄСТРУВАТИСЬ
//                 </span>{" "}
//                 для відслідковування замовлення
//               </p>
//             )}
//             <p className={css.labelMi}>Особисті дані</p>
//             <div className={css.wrapUserData}>
//               <input
//                 className={css.inputBig}
//                 type="text"
//                 placeholder="Ім'я"
//                 value={name}
//                 onChange={nameChange}
//               />
//               {/* <input
//                 className={css.inputSmall}
//                 type="text"
//                 placeholder="По-батькові"
//                 value={fatherName}
//                 onChange={fatherNameChange}
//               /> */}
//               <input
//                 className={css.inputBig}
//                 type="text"
//                 placeholder="Прізвище"
//                 value={surName}
//                 onChange={surNameChange}
//               />
//               <input
//                 className={css.inputBig}
//                 type="tel"
//                 placeholder="Телефон"
//                 value={phone}
//                 onChange={handlePhoneChange}
//                 required
//               />
//             </div>
//             <div className={css.deliveryChoisWrap}>
//               <div
//                 className={css.choisWrap}
//                 onClick={() => handleOptionClick("Доставка")}
//               >
//                 <div className={css.choisWi}>
//                   {selectedOption === "Доставка" && (
//                     <div className={css.wi}></div>
//                   )}
//                 </div>
//                 <p className={css.choisP}>Я отримувач</p>
//               </div>
//             </div>
//             {choisDostavka && (
//               <div className={css.wrapUserData}>
//                 <div className={css.chousBooksSelect}>
//                   <select
//                     className={css.customSelect}
//                     value={selectedCountry}
//                     onChange={(e) => setSelectedCountry(e.target.value)}
//                   >
//                     <option className={css.customOpin} value="0">
//                       Країна
//                     </option>
//                     <option className={css.customOpin} value="1">
//                       Україна
//                     </option>
//                   </select>
//                   <img src={arrowImp} className={css.customArrowSelect} />
//                 </div>

//                 <div className={css.chousBooksSelect}>
//                   <input
//                     className={css.inputSmallWrap}
//                     type="text"
//                     value={cityName}
//                     onChange={handleInputChange}
//                     placeholder="Місто"
//                   />
//                   {ulVisible && (
//                     <ul className={css.ulWrapBigCity}>
//                       {cities.length > 0 &&
//                         cities.map((city, index) => {
//                           return (
//                             <li
//                               onClick={() => handleCityClick(city)}
//                               key={index}
//                               className={css.liInListSitu}
//                             >
//                               {city.SettlementTypeDescription},
//                               {city.Description}, {city.AreaDescription}
//                             </li>
//                           );
//                         })}
//                     </ul>
//                   )}
//                   <img src={arrowImp} className={css.customArrowSelect} />
//                 </div>
//                 <div className={css.chousBooksSelectBig}>
//                   <select
//                     className={css.customSelect}
//                     value={selectedDeliveryMethod}
//                     onChange={(e) => setSelectedDeliveryMethod(e.target.value)}
//                   >
//                     <option className={css.customOpin} value="0">
//                       Спосіб доставки
//                     </option>
//                     <option className={css.customOpin} value="1">
//                       Нова пошта
//                     </option>
//                   </select>
//                   <img src={arrowImp} className={css.customArrowSelect} />
//                 </div>
//                 {/* <div className={css.chousBooksSelectBig}>
//                   <select
//                     className={css.customSelect}
//                     onChange={handleSelectChange}
//                   >
//                     <option className={css.customOpin} value="0">
//                       Нова пошта номер
//                     </option>
//                     {departments.length > 0 &&
//                       departments.map((el, index) => {
//                         return (
//                           <option
//                             className={css.customOpin}
//                             key={index}
//                             value={index}
//                           >
//                             {el.Description}
//                           </option>
//                         );
//                       })}
//                   </select>
//                   <img src={arrowImp} className={css.customArrowSelect} />
//                 </div> */}
//                 <div className={css.chousBooksSelectBig}>
//                   <input
//                     type="text"
//                     className={css.customSelectInput}
//                     placeholder="Введіть номер відділення"
//                     value={searchTerm}
//                     onChange={handleDepartmentSearch}
//                     onClick={handleInputClick} // Show dropdown on input click
//                     disabled={
//                       !selectedCity?.Ref || selectedDeliveryMethod !== "1"
//                     }
//                   />
//                   {ulVisibleVid && (
//                     <ul className={css.ulWrapBigViddilena}>
//                       {filteredDepartments.length > 0 ? (
//                         filteredDepartments.map((department, index) => (
//                           <li
//                             key={index}
//                             onClick={() => handleDepartmentClick(department)}
//                             className={css.liInListSitu}
//                           >
//                             {department.Description}
//                           </li>
//                         ))
//                       ) : (
//                         <li className={css.noResultsItem}>
//                           Збігів не знайдено
//                         </li>
//                       )}
//                     </ul>
//                   )}
//                   <img
//                     src={arrowImp}
//                     className={css.customArrowSelect}
//                     alt="Arrow"
//                   />
//                 </div>
//               </div>
//             )}
//             {whoCust && (
//               <>
//                 <p className={css.labelMi}>Контактні дані отримувача</p>
//                 <div className={css.wrapUserData}>
//                   <input
//                     className={css.inputBig}
//                     type="text"
//                     placeholder="Ім'я"
//                     value={nameOtr}
//                     onChange={nameChangeOtr}
//                   />

//                   <input
//                     className={css.inputBig}
//                     type="text"
//                     placeholder="Прізвище"
//                     value={surNameOtr}
//                     onChange={surNameChangeOtr}
//                   />
//                   <input
//                     className={css.inputBig}
//                     type="tel"
//                     placeholder="Телефон"
//                     value={phoneOtr}
//                     onChange={handlePhoneChangeOtr}
//                     required
//                   />
//                 </div>
//               </>
//             )}

//             <button
//               type="submit"
//               className={css.orderConfirmation}
//               onClick={payParam}
//             >
//               Оформити замовлення
//             </button>
//           </div>
//           <div className={css.wrapProdForOrder}>
//             {cartProducts &&
//               cartProducts.map((el, index) => {
//                 return (
//                   <ProductInOrder
//                     key={index}
//                     el={el}
//                     removeProduct={removeProduct}
//                     handleQuantityChange={handleQuantityChange}
//                   />
//                 );
//               })}

//             <div className={css.lineWrap}></div>
//             <p className={css.sumOrder}>Всього: {totalPrice} грн</p>
//             <p className={css.sumOrder}>Знижка: {discountInHok} %</p>
//             <div className={css.discountWrapOrder}>
//               <p className={css.slonuInL}>
//                 Ви можете використати Ваші слони. Загальна кількість слонів{" "}
//                 <strong>{currentUs && currentUs.elefant}</strong>
//               </p>
//               <div className={css.promoButton} onClick={handleApplyelefant}>
//                 Застосувати
//               </div>
//             </div>
//             <div className={css.discountWrapOrder}>
//               <input
//                 className={css.promoInput}
//                 type="text"
//                 placeholder="Промокод"
//                 value={promoCode}
//                 onChange={(e) => setPromoCode(e.target.value)}
//               />
//               <div className={css.promoButton} onClick={handleApplyPromoCode}>
//                 Застосувати
//               </div>
//             </div>
//             <p className={css.sum}>Сума: {newFinValue} грн</p>
//           </div>
//         </div>
//       </div>
//       {loading && (
//         <div className={css.spinerWrap}>
//           <img src={logoForSlidef} className={css.loadingLogo} alt="Loading" />
//         </div>
//       )}
//       <Footer />
//     </>
//   );
// };

// export default withUserData(Order);
import React, { useState, useEffect } from "react";
import Footer from "../standartComponent/footer/footer";
import Header from "../standartComponent/header/header";
import css from "./order.module.css";
import { v4 as uuidv4 } from "uuid";
import Swal from "sweetalert2";
import withUserData from "../HOK/withUserData";

import logoForSlidef from "../../svg/logoForSlidef.svg";
import arrowImp from "../../img/arrowDownPick.png";

import axios from "axios";
import ProductInOrder from "./productInOrder";
import { useCartCalculations } from "./useCartCalculations";

import {
  getDocs,
  getDoc,
  doc,
  setDoc,
  collection,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../../firebase";

/* ================== NP API (простий, як у ChangeData) ================== */
const NP_API_URL = "https://api.novaposhta.ua/v2.0/json/";

async function npGetCitiesSimple(apiKey, query) {
  if (!apiKey || !query?.trim()) return [];
  const body = {
    apiKey,
    modelName: "Address",
    calledMethod: "getCities",
    methodProperties: { FindByString: query },
  };
  const res = await fetch(NP_API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const json = await res.json();
  return Array.isArray(json?.data) ? json.data : [];
}

async function npGetWarehousesSimple(apiKey, cityRef) {
  if (!apiKey || !cityRef) return [];
  const body = {
    apiKey,
    modelName: "AddressGeneral",
    calledMethod: "getWarehouses",
    methodProperties: { CityRef: cityRef, Page: "1", Limit: "500" },
  };
  const res = await fetch(NP_API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const json = await res.json();
  return Array.isArray(json?.data) ? json.data : [];
}

/* ================== COMPONENT ================== */
const Order = ({ setLogin, user, discountInHok }) => {
  const uid = uuidv4();

  /* ===== user / profile ===== */
  const [currentUs, setCurrentUs] = useState(null);

  /* ===== ui / loaders ===== */
  const [loading, setLoading] = useState(false);

  /* ===== customer main data ===== */
  const [name, setName] = useState("");
  const [surName, setSurName] = useState("");
  const [phone, setPhone] = useState("");

  /* ===== receiver data ===== */
  const [nameOtr, setNameOtr] = useState("");
  const [surNameOtr, setSurNameOtr] = useState("");
  const [phoneOtr, setPhoneOtr] = useState("");

  /* ===== ui toggles ===== */
  const [isNewBuyer, setIsNewBuyer] = useState(true);
  const [selectedOption, setSelectedOption] = useState(null); // "Доставка" -> Я отримувач
  const [whoCust, setWhoCust] = useState(true); // показувати блок отримувача
  const [choisDostavka] = useState(true);

  /* ===== NP key & geography (спрощено) ===== */
  const [novaPoshtaKey, setNovaPoshtaKey] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("1"); // UA
  const [selectedDeliveryMethod, setSelectedDeliveryMethod] = useState("1"); // НП

  const [cityName, setCityName] = useState("");
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);

  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [ulVisible, setUlVisible] = useState(false); // список міст

  /* ===== cart / promo ===== */
  const [cartProducts, setCartProducts] = useState([]);
  const [countProductForCart, setCountProductForCart] = useState(0);
  const [promoApplied, setPromoApplied] = useState(false);

  const {
    totalPrice,
    newFinValue,
    promoCode,
    setPromoCode,
    applyPromoCode,
    applyElefant,
  } = useCartCalculations({
    cartProducts,
    discountInHok,
    currentUser: currentUs,
  });

  /* ================== LOAD NP KEY & USER ================== */
  useEffect(() => {
    const fetchNovaPoshtaKey = async () => {
      try {
        const snap = await getDoc(doc(db, "novapost", "novaPoshtaData"));
        if (snap.exists()) setNovaPoshtaKey(snap.data().key || "");
      } catch (e) {
        console.error("NP key load error:", e);
      }
    };
    fetchNovaPoshtaKey();
  }, []);

  useEffect(() => {
    const fetchCurrentUser = async () => {
      if (!user?.uid) return;
      const snap = await getDoc(doc(db, "users", user.uid));
      if (snap.exists()) setCurrentUs(snap.data());
    };
    fetchCurrentUser();
  }, [user]);

  /* ================== PREFILL FROM PROFILE (без автопоказів) ================== */
  useEffect(() => {
    if (!currentUs) return;

    if (currentUs.displayName) {
      const [first, last] = (currentUs.displayName || "").split(" ");
      setName(first || "");
      setSurName(last || "");
      setPhone(currentUs.phone || "");
    }

    if (currentUs?.deliveryCity?.Ref) {
      setSelectedCity(currentUs.deliveryCity);
      setCityName(currentUs.deliveryCity?.Description || "");
      setSelectedDepartment(currentUs.deliveryDepartment || "");
      setSelectedCountry("1");
      setSelectedDeliveryMethod("1");
    } else {
      setSelectedCity(null);
      setCityName("");
      setSelectedDepartment("");
      setSelectedCountry("1");
      setSelectedDeliveryMethod("1");
    }
  }, [currentUs]);

  /* ================== LOAD WAREHOUSES (простий) ================== */
  useEffect(() => {
    (async () => {
      if (!novaPoshtaKey || !selectedCity?.Ref) {
        setDepartments([]);
        return;
      }
      const list = await npGetWarehousesSimple(novaPoshtaKey, selectedCity.Ref);
      setDepartments(list);
    })();
  }, [novaPoshtaKey, selectedCity]);

  /* ================== CITY SEARCH (простий) ================== */
  const handleCityInputChange = async (e) => {
    const val = e.target.value;
    setCityName(val);
    setUlVisible(true);
    setSelectedCity(null);
    setSelectedDepartment("");
    if (!novaPoshtaKey) return;
    const list = await npGetCitiesSimple(novaPoshtaKey, val);
    setCities(list || []);
  };

  const handleCityClick = async (city) => {
    setSelectedCity(city);
    setCityName(city?.Description || "");
    setUlVisible(false);
    setSelectedDepartment("");
  };

  /* ================== CART LOAD ================== */
  useEffect(() => {
    const fetchProducts = async () => {
      const productsRef = collection(db, "product");
      const productsSnapshot = await getDocs(productsRef);
      const productsList = productsSnapshot.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));

      const bundlesSnapshot = await getDocs(collection(db, "bundles"));
      const bundles = bundlesSnapshot.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));

      const actionsSnapshot = await getDocs(collection(db, "actions"));
      const actions = actionsSnapshot.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));

      const salesSnapshot = await getDocs(collection(db, "sales"));
      const sales = salesSnapshot.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));

      const now = new Date();
      const cartLocal = JSON.parse(localStorage.getItem("cart") || "[]");

      const withFlags = cartLocal
        .map((ci) => {
          const product = productsList.find((p) => p.id === ci.uid);
          if (!product) return null;

          let actionDiscount = null;
          const matchedAction = actions.find((a) => {
            const start = a.startDate ? new Date(a.startDate) : null;
            const end = a.endDate ? new Date(a.endDate) : null;
            if (end && now > end) return false;
            if (start && now < start) return false;

            const matchProduct = a.appliesTo?.products?.includes(product.id);
            const productSeries = Array.isArray(product.seria)
              ? product.seria
              : typeof product.seria === "string" && product.seria !== ""
              ? [product.seria]
              : [];
            const matchSeries = productSeries.some((ser) =>
              a.appliesTo?.series?.includes(ser)
            );

            const productAuthors = Array.isArray(product.textAutor)
              ? product.textAutor.map((x) => (x || "").split(" ")[0].trim())
              : typeof product.textAutor === "string" &&
                product.textAutor !== ""
              ? [product.textAutor.split(" ")[0].trim()]
              : [];
            const actionAuthors = Array.isArray(a.appliesTo?.authors)
              ? a.appliesTo.authors.map((x) => (x || "").split(" ")[0].trim())
              : [];
            const matchAuthor = productAuthors.some((x) =>
              actionAuthors.includes(x)
            );
            return matchProduct || matchSeries || matchAuthor;
          });
          if (matchedAction) actionDiscount = matchedAction.discountPercent;

          let saleDiscount = null;
          const matchedSale = sales.find((s) => {
            const start = s.startDate ? new Date(s.startDate) : null;
            const end = s.endDate ? new Date(s.endDate) : null;
            if (end && now > end) return false;
            if (start && now < start) return false;

            const applies = s.appliesTo || {};
            const matchProduct =
              Array.isArray(applies.products) &&
              applies.products.includes(product.id);

            const productSeries =
              Array.isArray(product.seria) && product.seria.length
                ? product.seria
                : typeof product.seria === "string" && product.seria !== ""
                ? [product.seria]
                : Array.isArray(product.series) && product.series.length
                ? product.series
                : typeof product.series === "string" && product.series !== ""
                ? [product.series]
                : [];
            const matchSeries =
              Array.isArray(applies.series) &&
              productSeries.some((ser) => applies.series.includes(ser));

            const productAuthors = Array.isArray(product.textAutor)
              ? product.textAutor.map((x) => (x || "").split(" ")[0].trim())
              : typeof product.textAutor === "string" &&
                product.textAutor !== ""
              ? [product.textAutor.split(" ")[0].trim()]
              : [];
            const saleAuthors = Array.isArray(applies.authors)
              ? applies.authors.map((x) => (x || "").split(" ")[0].trim())
              : [];
            const matchAuthor = productAuthors.some((x) =>
              saleAuthors.includes(x)
            );

            return matchProduct || matchSeries || matchAuthor;
          });
          if (matchedSale)
            saleDiscount = Number(matchedSale.discountPercent) || 0;

          return {
            ...product,
            quantity: ci.quantity,
            actionDiscountPercent: actionDiscount,
            saleDiscountPercent: saleDiscount,
            uid: ci.uid,
          };
        })
        .filter(Boolean);

      // bundles
      bundles.forEach((b) => {
        const ids = (b.products || []).map((p) => (p.productId || "").trim());
        const inCart = withFlags.filter((p) =>
          ids.includes((p.id || "").trim())
        );
        if (inCart.length >= (b.products || []).length) {
          inCart.forEach((item) => {
            const matchBundleItem = (b.products || []).find(
              (p) => (p.productId || "").trim() === (item.id || "").trim()
            );
            if (matchBundleItem?.discount)
              item.actionDiscountPercent = matchBundleItem.discount;
          });
        }
      });

      setCartProducts(withFlags);
    };
    fetchProducts();
  }, []);

  useEffect(() => {
    const total = (cartProducts || []).reduce(
      (acc, p) => acc + (p.quantity || 0),
      0
    );
    setCountProductForCart(total);
  }, [cartProducts]);

  const handleQuantityChange = (uid, quantity) => {
    const updated = (cartProducts || []).map((p) =>
      p.uid === uid ? { ...p, quantity } : p
    );
    setCartProducts(updated);
    const cart = JSON.parse(localStorage.getItem("cart") || "[]");
    const newCart = cart.map((p) => (p.uid === uid ? { ...p, quantity } : p));
    localStorage.setItem("cart", JSON.stringify(newCart));
  };

  const removeProduct = (uid) => {
    const updated = (cartProducts || []).filter((p) => p.uid !== uid);
    setCartProducts(updated);
    localStorage.setItem("cart", JSON.stringify(updated));
  };

  /* ================== PROMO / ELEPHANTS ================== */
  useEffect(() => {
    const usedPromo = localStorage.getItem("usedPromoCode");
    if (usedPromo) setPromoApplied(true);
  }, []);

  const handleApplyPromoCode = React.useCallback(async () => {
    if (!cartProducts?.length) {
      Swal.fire({
        icon: "info",
        title: "Зачекайте",
        text: "Товари ще не завантажені. Спробуйте за кілька секунд.",
      });
      return;
    }
    const promoCollectionRef = collection(db, "promo");
    const snapshot = await getDocs(promoCollectionRef);

    let found = false;
    for (const docSnap of snapshot.docs) {
      const pd = { ...docSnap.data(), id: docSnap.id };
      if (
        (pd.code || "").trim().toLowerCase() ===
        (promoCode || "").trim().toLowerCase()
      ) {
        found = true;
        const ok = await applyPromoCode(pd, cartProducts);
        if (ok) {
          Swal.fire({
            icon: "success",
            title: "Промокод застосовано",
            text: `Знижка ${pd.discount}% активована!`,
          });
          localStorage.setItem("usedPromoCode", promoCode);
          setPromoApplied(true);
          setPromoCode("");
        } else {
          Swal.fire({
            icon: "info",
            title: "Не застосовано",
            text: "Цей промокод не підходить до вибраних товарів.",
          });
        }
        break;
      }
    }
    if (!found)
      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Такого промокоду не існує.",
      });
  }, [applyPromoCode, promoCode, cartProducts, setPromoCode]);

  const handleApplyelefant = async () => {
    if (!currentUs || !currentUs.elefant || parseInt(currentUs.elefant) === 0) {
      Swal.fire({
        icon: "info",
        title: "Увага",
        text: "У вас немає доступних слонів для списання.",
      });
      return;
    }
    const elephantsUsed = await applyElefant(async (uidUpdate) => {
      const userDocRef = doc(db, "users", uidUpdate);
      await setDoc(userDocRef, { elefant: "0" }, { merge: true });
      setCurrentUs((p) => ({ ...(p || {}), elefant: "0" }));
    });
    if (elephantsUsed === false) {
      Swal.fire({
        icon: "info",
        title: "Увага",
        text: "У вас немає доступних слонів для списання.",
      });
    } else {
      Swal.fire({
        icon: "success",
        title: "Слони застосовані!",
        text: `Сума замовлення зменшена на ${elephantsUsed} грн.`,
      });
    }
  };

  /* ================== VALIDATION ================== */
  const validateForm = () => {
    if (
      !(name || "").trim() ||
      !(surName || "").trim() ||
      !(phone || "").trim()
    ) {
      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Заповніть: Ім'я, Прізвище, Телефон.",
      });
      return false;
    }
    if (
      !selectedOption &&
      (!(nameOtr || "").trim() ||
        !(surNameOtr || "").trim() ||
        !(phoneOtr || "").trim())
    ) {
      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Заповніть дані отримувача.",
      });
      return false;
    }
    if (!(cityName || "").trim()) {
      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Введіть місто доставки.",
      });
      return false;
    }
    if (selectedDeliveryMethod === "1" && !(selectedDepartment || "").trim()) {
      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Виберіть відділення Нової пошти.",
      });
      return false;
    }
    return true;
  };

  /* ================== PAY ================== */
  const payParam = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      setLoading(true);

      const json = JSON.stringify(cartProducts || []);
      const us = user ? user.uid : "";

      const orderPayload = {
        uid,
        choice: json,
        totalPrice,
        finishPrice: newFinValue,
        phone,
        name,
        surName,
        discount: discountInHok,
        nameOtr,
        surNameOtr,
        phoneOtr,
        isNewBuyer,
        cityName,
        selectedDepartment,
        pay: "card",
        paymentStatus: "false",
        user: us,
        status: "Очікує підтвердження",
        createdAt: serverTimestamp(),
      };

      await setDoc(doc(db, "orders", uid), orderPayload);

      const payload = {
        id: uid,
        amount: totalPrice * 100,
        ccy: 980,
        merchantPaymInfo: {
          reference: "84d0070ee4e44667b31371d8f8813947",
          destination: "Оплата товарів час майстрів",
          comment: "Оплата товарів час майстрів",
          customerEmails: [],
          basketOrder: (cartProducts || []).map((p) => ({
            name: p.bookName,
            qty: p.quantity,
            sum: p.price * 100,
            icon: p.imageList?.[0],
            unit: "шт.",
            code: p.ISBN,
          })),
        },
        webHookUrl: "https://chas-maistriv.com.ua/api/webhook",
        paymentType: "debit",
        saveCardData: {
          saveCard: true,
          walletId: "69f780d841a0434aa535b08821f4822c",
        },
        redirectUrl: "https://chas-maistriv.com.ua/",
        initiationKind: "merchant",
        tds: true,
        newProduct: orderPayload,
      };

      const resp = await axios.post(
        "https://chas-maistriv.com.ua/api/create-payment",
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      if (resp?.data && resp?.statusText === "OK") {
        localStorage.removeItem("cart");
        window.location.href = resp.data.pageUrl;
      } else {
        throw new Error("Помилка створення платежу");
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Не вдалося створити оплату. Спробуйте пізніше.",
      });
      setLoading(false);
    }
  };

  /* ================== SIMPLE HANDLERS ================== */
  const handleNewBuyerClick = () => setIsNewBuyer(true);
  const handleAlwaysBuyerClick = () => setIsNewBuyer(false);
  const handleOptionClick = (opt) => {
    if (selectedOption === opt) {
      setSelectedOption("");
      setWhoCust(true);
    } else {
      setSelectedOption(opt);
      setWhoCust(false);
    }
  };

  /* ================== RENDER ================== */
  return (
    <>
      <div className={css.blueHeaderOrder}>
        <div className={css.blueHeaderOrderEnter}>
          <h3 className={css.titleH3OrderEnter}>Оформлення замовлення</h3>
        </div>
      </div>

      <div className={css.wrapCenterOrder}>
        <div className={css.wrapCenterOrderSmall}>
          <div className={css.firstBlockWrap}>
            {!currentUs && (
              <div className={css.newUserOrNoWrap}>
                <div
                  className={`${css.newAlwaysBayer} ${
                    isNewBuyer ? css.newBayer : ""
                  }`}
                  onClick={handleNewBuyerClick}
                >
                  Я новий покупець
                </div>
                <div
                  className={`${css.newAlwaysBayer} ${
                    !isNewBuyer ? css.newBayer : ""
                  }`}
                  onClick={handleAlwaysBuyerClick}
                >
                  Я постійний покупець
                </div>
              </div>
            )}

            {!user && (
              <p className={css.registerToOrder}>
                <span
                  onClick={() => setLogin(true)}
                  className={css.registerToOrderSpan}
                >
                  ЗАРЕЄСТРУВАТИСЬ
                </span>{" "}
                для відслідковування замовлення
              </p>
            )}

            <p className={css.labelMi}>Особисті дані</p>
            <div className={css.wrapUserData}>
              <input
                className={css.inputBig}
                type="text"
                placeholder="Ім'я"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <input
                className={css.inputBig}
                type="text"
                placeholder="Прізвище"
                value={surName}
                onChange={(e) => setSurName(e.target.value)}
              />
              <input
                className={css.inputBig}
                type="tel"
                placeholder="Телефон"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
              />
            </div>

            <div className={css.deliveryChoisWrap}>
              <div
                className={css.choisWrap}
                onClick={() => handleOptionClick("Доставка")}
              >
                <div className={css.choisWi}>
                  {selectedOption === "Доставка" && <div className={css.wi} />}
                </div>
                <p className={css.choisP}>Я отримувач</p>
              </div>
            </div>

            {choisDostavka && (
              <div className={css.wrapUserData}>
                <div className={css.chousBooksSelect}>
                  <select
                    className={css.customSelect}
                    value={selectedCountry}
                    onChange={(e) => setSelectedCountry(e.target.value)}
                  >
                    <option className={css.customOpin} value="1">
                      Україна
                    </option>
                  </select>
                  <img
                    src={arrowImp}
                    className={css.customArrowSelect}
                    alt="Arrow"
                  />
                </div>

                {/* Місто (як у ChangeData, кастомний список) */}
                <div className={css.chousBooksSelect}>
                  <input
                    className={css.inputSmallWrap}
                    type="text"
                    value={cityName}
                    onChange={handleCityInputChange}
                    placeholder="Місто"
                    onFocus={() => setUlVisible(true)}
                  />
                  {ulVisible && Array.isArray(cities) && cities.length > 0 && (
                    <ul className={css.ulWrapBigCity}>
                      {cities.map((city, i) => (
                        <li
                          onClick={() => handleCityClick(city)}
                          key={`${city.Ref || i}-${i}`}
                          className={css.liInListSitu}
                        >
                          {city.SettlementTypeDescription
                            ? `${city.SettlementTypeDescription}, `
                            : ""}
                          {city.Description}
                          {city.AreaDescription
                            ? `, ${city.AreaDescription}`
                            : ""}
                        </li>
                      ))}
                    </ul>
                  )}
                  <img
                    src={arrowImp}
                    className={css.customArrowSelect}
                    alt="Arrow"
                  />
                </div>

                {/* Метод доставки (фіксовано "НП") */}
                <div className={css.chousBooksSelectBig}>
                  <select
                    className={css.customSelect}
                    value={selectedDeliveryMethod}
                    onChange={(e) => setSelectedDeliveryMethod(e.target.value)}
                  >
                    <option className={css.customOpin} value="1">
                      Нова пошта
                    </option>
                  </select>
                  <img
                    src={arrowImp}
                    className={css.customArrowSelect}
                    alt="Arrow"
                  />
                </div>

                {/* Відділення — без попапів і авто-відкривань, звичайний select */}
                <div className={css.chousBooksSelectBig}>
                  <select
                    className={css.customSelect}
                    value={selectedDepartment}
                    onChange={(e) => setSelectedDepartment(e.target.value)}
                    disabled={
                      !selectedCity?.Ref || selectedDeliveryMethod !== "1"
                    }
                  >
                    {selectedDepartment ? (
                      <option value={selectedDepartment}>
                        {selectedDepartment}
                      </option>
                    ) : (
                      <option value="">Оберіть відділення</option>
                    )}
                    {Array.isArray(departments) && departments.length > 0 ? (
                      departments.map((d, idx) => (
                        <option
                          key={`${d.Ref || idx}`}
                          value={d?.Description || ""}
                        >
                          {d?.Description || "Відділення"}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>
                        Відділень не знайдено
                      </option>
                    )}
                  </select>
                  <img
                    src={arrowImp}
                    className={css.customArrowSelect}
                    alt="Arrow"
                  />
                </div>
              </div>
            )}

            {whoCust && (
              <>
                <p className={css.labelMi}>Контактні дані отримувача</p>
                <div className={css.wrapUserData}>
                  <input
                    className={css.inputBig}
                    type="text"
                    placeholder="Ім'я"
                    value={nameOtr}
                    onChange={(e) => setNameOtr(e.target.value)}
                  />
                  <input
                    className={css.inputBig}
                    type="text"
                    placeholder="Прізвище"
                    value={surNameOtr}
                    onChange={(e) => setSurNameOtr(e.target.value)}
                  />
                  <input
                    className={css.inputBig}
                    type="tel"
                    placeholder="Телефон"
                    value={phoneOtr}
                    onChange={(e) => setPhoneOtr(e.target.value)}
                    required
                  />
                </div>
              </>
            )}

            <button
              type="submit"
              className={css.orderConfirmation}
              onClick={payParam}
            >
              Оформити замовлення
            </button>
          </div>

          <div className={css.wrapProdForOrder}>
            {cartProducts?.map((el, i) => (
              <ProductInOrder
                key={i}
                el={el}
                removeProduct={removeProduct}
                handleQuantityChange={handleQuantityChange}
              />
            ))}

            <div className={css.lineWrap} />
            <p className={css.sumOrder}>Всього: {totalPrice} грн</p>
            <p className={css.sumOrder}>Знижка: {discountInHok} %</p>

            <div className={css.discountWrapOrder}>
              <p className={css.slonuInL}>
                Ви можете використати Ваші слони. Загальна кількість слонів{" "}
                <strong>{currentUs && currentUs.elefant}</strong>
              </p>
              <div className={css.promoButton} onClick={handleApplyelefant}>
                Застосувати
              </div>
            </div>

            <div className={css.discountWrapOrder}>
              <input
                className={css.promoInput}
                type="text"
                placeholder="Промокод"
                value={promoCode}
                onChange={(e) => setPromoCode(e.target.value)}
                disabled={promoApplied}
              />
              <div className={css.promoButton} onClick={handleApplyPromoCode}>
                Застосувати
              </div>
            </div>

            <p className={css.sum}>Сума: {newFinValue} грн</p>
          </div>
        </div>
      </div>

      {loading && (
        <div className={css.spinerWrap}>
          <img src={logoForSlidef} className={css.loadingLogo} alt="Loading" />
        </div>
      )}
    </>
  );
};

export default withUserData(Order);
